import { useTheme } from '../../../context/ThemeContext';

/**
 * Portada de clase que respeta el tema: en light usa la variante `-light.webp`
 * (si existe), en dark/carnaval la base. Si la variante light no existe, cae a la base.
 */
export default function ClassCover({ url, alt, className }: { url: string; alt?: string; className?: string }) {
  const { theme } = useTheme();
  // Inserta -light antes de la extensión, preservando un posible ?v= de cache-busting.
  const lightUrl = url.replace(/\.webp(\?.*)?$/i, '-light.webp$1');
  const src = theme === 'light' ? lightUrl : url;
  return (
    <img
      key={src}
      src={src}
      alt={alt || ''}
      loading="lazy"
      className={className}
      onError={(e) => {
        const img = e.currentTarget;
        if (img.src.includes('-light.webp')) img.src = url; // fallback a la versión base (dark)
      }}
    />
  );
}
